import { API_URL } from 'shared/config/env';

export const fetchCsrfToken = async () => {
  const res = await fetch(`${API_URL}/auth/csrf/`, {
    credentials: 'include',
  });
  if (!res.ok) throw new Error('CSRFトークン取得失敗');
  return res;
};

export const getCsrfToken = () => {
  const match = document.cookie.match(/(?:^|; )csrftoken=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
};

export type MeResponse = {
  id: number;
  username: string;
  email: string;
  full_name: string;
  roles: string[];
};

export type LoginSite = 'member' | 'supporter' | 'manager';

export type LoginResponse = {
  id: number;
  username: string;
  email: string;
  full_name: string;
  site: LoginSite;
  roles: string[];
};

export type LoginResult =
  | { ok: true; data: LoginResponse }
  | { ok: false; status: number; error?: string };

export const isLoginError = (
  result: LoginResult
): result is { ok: false; status: number; error?: string } =>
  result.ok === false;

export const fetchMe = async (): Promise<MeResponse> => {
  const res = await fetch(`${API_URL}/auth/me/`, {
    credentials: 'include',
  });
  if (!res.ok) throw new Error('認証情報取得失敗');
  return await res.json();
};

export const loginWithSession = async (
  loginId: string,
  password: string,
  site: LoginSite
): Promise<LoginResult> => {
  await fetchCsrfToken();
  const csrfToken = getCsrfToken();
  const res = await fetch(`${API_URL}/auth/login/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
    },
    credentials: 'include',
    body: JSON.stringify({ login_id: loginId, password, site }),
  });
  if (res.ok) {
    const data = (await res.json()) as LoginResponse;
    return { ok: true, data };
  }

  let error: string | undefined;
  try {
    const body = (await res.json()) as { detail?: string };
    error = body.detail;
  } catch {
    error = undefined;
  }
  return { ok: false, status: res.status, error };
};

export type LogoutResult = { ok: true } | { ok: false; status: number };

export const logoutWithSession = async (): Promise<LogoutResult> => {
  await fetchCsrfToken();
  const csrfToken = getCsrfToken();
  const res = await fetch(`${API_URL}/auth/logout/`, {
    method: 'POST',
    headers: {
      ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
    },
    credentials: 'include',
  });
  if (res.ok) {
    return { ok: true };
  }
  return { ok: false, status: res.status };
};
